import React, { useEffect } from "react";

const blockedKeys = new Set(["c", "C", "x", "X", "p", "P", "s", "S", "u", "U", "a", "A"]);

/** Blocks copy, cut, print, and drag on quiz/exam content. No visible watermark. */
const ContentGuard = ({ children }) => {
  useEffect(() => {
    const block = (event) => event.preventDefault();
    const onCopy = (event) => {
      event.preventDefault();
      if (event.clipboardData) event.clipboardData.setData("text/plain", "");
    };
    const onKeyDown = (event) => {
      const key = event.key;
      if (key === "PrintScreen") {
        event.preventDefault();
        return;
      }
      if ((event.ctrlKey || event.metaKey) && blockedKeys.has(key)) {
        event.preventDefault();
      }
    };
    const onContextMenu = (event) => event.preventDefault();
    const onDragStart = (event) => event.preventDefault();

    document.addEventListener("copy", onCopy, true);
    document.addEventListener("cut", onCopy, true);
    document.addEventListener("paste", block, true);
    document.addEventListener("keydown", onKeyDown, true);
    document.addEventListener("contextmenu", onContextMenu, true);
    document.addEventListener("dragstart", onDragStart, true);
    document.addEventListener("selectstart", block, true);
    document.body.classList.add("nexorah-content-guard");

    return () => {
      document.removeEventListener("copy", onCopy, true);
      document.removeEventListener("cut", onCopy, true);
      document.removeEventListener("paste", block, true);
      document.removeEventListener("keydown", onKeyDown, true);
      document.removeEventListener("contextmenu", onContextMenu, true);
      document.removeEventListener("dragstart", onDragStart, true);
      document.removeEventListener("selectstart", block, true);
      document.body.classList.remove("nexorah-content-guard");
    };
  }, []);

  return (
    <div
      className="nexorah-guard"
      onCopy={(event) => event.preventDefault()}
      onCut={(event) => event.preventDefault()}
      onPaste={(event) => event.preventDefault()}
      onContextMenu={(event) => event.preventDefault()}
      onDragStart={(event) => event.preventDefault()}
      onSelectStart={(event) => event.preventDefault()}
    >
      {children}
    </div>
  );
};

export default ContentGuard;
